import BaseTable from 'packages/tables/BaseTable';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import useTablePagination from 'packages/hooks/use-table-pagination';
import {useQuery} from '@apollo/client';
import {PLAYER_LIST} from 'packages/constants/table-constants';
import {Tournament, UserInscriptions} from 'packages/common-types/schema-types';
import {GET_TOURNAMENTS} from 'packages/graphql/v2/queries';
import {useState} from 'react';
import {v4 as uuidv4} from 'uuid';
import {GetTournamentsData} from 'packages/common-types/queries-types';
import Select from 'react-select';
import {renderAddress} from 'packages/common-utils/helpers';

const RegisteredPlayers = () => {
  const {data, loading} = useQuery<GetTournamentsData>(GET_TOURNAMENTS);
  const [selectedTournament, setSelectedTournament] =
    useState<Tournament | null>(null);
  const [registeredPlayers, setRegisteredPlayers] = useState<
    UserInscriptions[]
  >([]);

  const {onChangePage, onChangeRowsPerPage, page, rowsPerPage} =
    useTablePagination();

  const handleSelectTournament = (value: Tournament) => {
    console.log('VALUE ', value);
    setSelectedTournament(value);
    setRegisteredPlayers(value?.inscriptions);
  };

  return (
    <>
      <Select
        styles={{
          container: (props) => ({
            ...props,
            marginTop: 20,
          }),
        }}
        isLoading={loading}
        value={selectedTournament}
        onChange={handleSelectTournament}
        placeholder="Selecciona un torneo"
        options={data?.getTournaments}
        getOptionLabel={(option) =>
          `${option.name}:${option.conditions.modalityGame}`
        }
        getOptionValue={(option) => JSON.stringify(option)}
      />
      {registeredPlayers && (
        <>
          <BaseTable headers={PLAYER_LIST}>
            {registeredPlayers
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(({user, state}) => {
                console.log(user);
                return (
                  <TableRow key={uuidv4()}>
                    <TableCell component="th" scope="row">
                      {user.email}
                    </TableCell>
                    <TableCell align="right">{user.fullName}</TableCell>
                    <TableCell align="right">{user.phoneNumber}</TableCell>
                    <TableCell align="right">{user.gender}</TableCell>
                    <TableCell align="right">
                      {renderAddress(user.address)}
                    </TableCell>
                    <TableCell align="right">{user.clubId}</TableCell>
                    <TableCell align="right">{state}</TableCell>
                    <TableCell align="right">{user.document}</TableCell>
                  </TableRow>
                );
              })}
          </BaseTable>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={registeredPlayers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={onChangePage}
            onChangeRowsPerPage={onChangeRowsPerPage}
          />
        </>
      )}
    </>
  );
};

export default RegisteredPlayers;
